import type { SectionConfig } from '../../config';
import { FieldsRenderer } from '../../fields-renderer';
import { SectionShell } from '../section-shell';

export type LeaseInformationSectionProps = {
  config: SectionConfig;
};

export const LeaseInformationSection = ({ config }: LeaseInformationSectionProps) => (
  <SectionShell
    // Default heading; consumers pass '' to hide it (e.g. inside an accordion).
    title={config.title ?? 'Lease details'}
    subtitle={config.subtitle}
    slots={config.slots}
    spacing={config.spacing}
  >
    <FieldsRenderer fields={config.fields} sectionKey="leaseInformation" />
  </SectionShell>
);
